import { useEffect, useMemo, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Controller, useForm } from "react-hook-form";
import Swal from "sweetalert2";
import { useAPIQuery } from "@dev2_techwalnut/tw-api-query-hook";
import Select from "react-select";
import secureLocalStorage from "react-secure-storage";
import SelectAll from "../../Base/SelectAll";

const CreateQualityParameter = () => {
    const userID = secureLocalStorage.getItem("userID");
    const navigate = useNavigate();

    // select dropdown
    const [unit, setUnit] = useState([]);

    const { useFetch } = useAPIQuery({
        key: "api/generic",
        endpoint: "/api/generic/",
    });

    const { data, isLoading } = useFetch({
        abortOnNewRequest: true,
        refetchOnWindowFocus: false,
        staleTime: 1000 * 60 * 3,
        retry: 3,
        keepPlaceholder: true,
        refetchOnReconnect: true,
    });

    const { useFetch: useQualityParams, useCreate } = useAPIQuery({
        key: "quality_parameter",
        endpoint: "/api/quality-parameters/",
    });

    const {
        data: qualityParamsDropdown,
        isLoading: loadingQualityParamsDropdown,
    } = useQualityParams({
        params: {
            action: "fetch-params",
        },
        abortOnNewRequest: true,
        refetchOnWindowFocus: false,
        staleTime: 1000 * 60 * 3,
        retry: 3,
        keepPlaceholder: true,
        refetchOnReconnect: true,
    });

    const handleCreateQualityParameter = (data) => {
        Swal.fire({
            title: "Quality Parameter Added!",
            text: data.message,
            icon: "success",
        }).then((result) => {
            if (result.isConfirmed) {
                setTimeout(() => {
                    navigate(-1);
                }, 2000);
            }
        });
    };

    const handleErrorQualityParameter = (data) => {
        Swal.fire({
            title: "Error Adding Quality Parameter",
            text: data?.data?.data?.message,
            icon: "error",
        });
    };

    const { mutate, isPending } = useCreate({
        params: {
            action: "item_association",
        },
        onSuccess: handleCreateQualityParameter,
        onError: handleErrorQualityParameter,
        retry: 2,
    });

    // react Hook form Props
    const {
        register,
        handleSubmit,
        formState: { errors },
        control,
        reset,
    } = useForm({ mode: "onChange" });

    // onSubmit handler to post form details
    const onSubmit = (data) => {
        var quality_parameter = {
            parameter_name: data.parameter_name,
            unit: data.unit?.value,
            // rule_type: data.rule_type,
            item_ids: data.item_id?.map((info) => info.value),
            // specifications_type: "",
            created_by: userID,
            updated_by: userID,
        };

        console.log(quality_parameter);

        mutate({
            data: quality_parameter,
        });
    };

    const itemDropdown = useMemo(() => {
        if (data) {
            return data.item
                ?.filter(
                    (i) =>
                        i?.category?.toLowerCase() ===
                            "Raw Material"?.toLowerCase() ||
                        i?.category?.toLowerCase() === "WIP"?.toLowerCase()
                )
                ?.map((info) => ({
                    value: info?.id,
                    label: info?.item_name,
                }));
        }
        return [];
    }, [data]);

    useEffect(() => {
        if (data) {
            setUnit(
                data?.typemaster?.filter(
                    (post) => post.category_value == "unit_of_measurement"
                )
            );
        }
    }, [data]);

    return (
        <>
            <div className="nk-block-head nk-block-head-sm">
                <div className="nk-block-between">
                    <div className="nk-block-head-content">
                        <h4 className="nk-block-title">
                            {" "}
                            Create Quality Parameter{" "}
                        </h4>
                    </div>
                </div>
            </div>
            <div className="col-lg-12 col-md-12 col-sm-12">
                <div class="card">
                    <div class="card-inner">
                        {/* For Form : Use React hook forms */}
                        <form
                            onSubmit={handleSubmit(onSubmit)}
                            autoComplete="off"
                        >
                            <div className="row g-4">
                                <div className="col-lg-6 col-md-6 col-sm-12">
                                    <label className="form-label">
                                        Parameter Name
                                        <span className="fs-8 text-danger">
                                            {" "}
                                            *
                                        </span>
                                    </label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        placeholder={
                                            loadingQualityParamsDropdown
                                                ? "Loading..."
                                                : "Enter parameter name"
                                        }
                                        id="text-forms-parameter-name"
                                        {...register("parameter_name", {
                                            required:
                                                "Parameter Name is required",
                                            validate: (value) => {
                                                if (!value) return true;
                                                const exists =
                                                    qualityParamsDropdown?.data?.some(
                                                        (param) =>
                                                            param.toLowerCase() ===
                                                            value.toLowerCase()
                                                    );
                                                return exists
                                                    ? "This parameter already exists"
                                                    : true;
                                            },
                                        })}
                                        disabled={loadingQualityParamsDropdown}
                                    />

                                    {errors.parameter_name && (
                                        <span className="fs-8 text-danger">
                                            {errors.parameter_name.message}
                                        </span>
                                    )}
                                </div>

                                <div className="col-lg-6 col-md-6 col-sm-12">
                                    <label className="form-label">
                                        Unit
                                        <span className="fs-8 text-danger">
                                            {" "}
                                            *
                                        </span>
                                    </label>
                                    <Controller
                                        render={({ field }) => (
                                            <Select
                                                {...field}
                                                options={unit?.map((info) => ({
                                                    value: info.name,
                                                    label: info.name,
                                                }))}
                                                isLoading={isLoading}
                                                isClearable={true}
                                                id="select-forms-unit"
                                            />
                                        )}
                                        defaultValue=""
                                        rules={{ required: true }}
                                        name="unit"
                                        control={control}
                                    />
                                    {errors.unit && (
                                        <span className="fs-8 text-danger">
                                            Unit is required
                                        </span>
                                    )}
                                </div>

                                <div className="col-lg-6 col-md-6 col-sm-12">
                                    <label className="form-label">
                                        Item Name
                                        <span className="fs-8 text-danger">
                                            {" "}
                                            *
                                        </span>
                                    </label>
                                    <Controller
                                        render={({ field }) => (
                                            <SelectAll
                                                {...field}
                                                options={itemDropdown}
                                                isLoading={isLoading}
                                                isClearable={true}
                                                id="select-forms-item-id"
                                            />
                                        )}
                                        defaultValue=""
                                        rules={{ required: true }}
                                        name="item_id"
                                        control={control}
                                    />
                                    {errors.item_id && (
                                        <span className="fs-8 text-danger">
                                            Item Name is required
                                        </span>
                                    )}
                                </div>

                                <div className="col-12">
                                    <div className="form-group">
                                        <button
                                            type="button"
                                            className="btn btn-md btn-light me-2"
                                            id="submit-button-backbutton"
                                            onClick={() => navigate(-1)}
                                        >
                                            Back
                                        </button>
                                        {isPending ? (
                                            <button
                                                type="button"
                                                id="button-specification-type-loading"
                                                className="btn btn-md text-dark"
                                                disabled
                                            >
                                                Loading...
                                            </button>
                                        ) : (
                                            <button
                                                type="submit"
                                                className="btn btn-md btn-primary"
                                                id="submit-button-create-specification-type"
                                            >
                                                Create
                                            </button>
                                        )}
                                    </div>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </>
    );
};

export default CreateQualityParameter;
